import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';

import UserRightsV2Api from 'flow/api/userrightsv2';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';

const USER_RIGHTS_QUERY_KEY = ['userRightsV2'];

interface UserRightItem {
    name: string;
    active: boolean;
    global: boolean;
    category: string;
    group?: string;
    editable?: boolean;
}

interface UserRightsResponseDTO {
    key: string;
    userRights: UserRightItem[];
}

const fetchUserRights = (): Promise<UserRightsResponseDTO[]> =>
    new Promise((resolve, reject) => {
        UserRightsV2Api.list(
            { onResult: resolve, onError: reject, onClientError: reject },
            undefined,
            undefined,
        );
    });

const useUserRights = () =>
    useAuthenticatedQuery({
        queryKey: USER_RIGHTS_QUERY_KEY,
        queryFn: fetchUserRights,
        staleTime: 60 * 60 * 1000,
    });

const useOwnUserRights = () => {
    const extensionKey = useAppSelector(selectOwnExtensionKey);
    const { data } = useUserRights();
    const userRights =
        data?.find((entry) => entry.key === extensionKey)?.userRights ?? [];
    return {
        canConfigureIncomingCalls: userRights.some(
            (right) =>
                right.name === 'configure_incoming_calls' && right.active,
        ),
        canConfigureOutgoingCalls: userRights.some(
            (right) =>
                right.name === 'configure_outgoing_calls' && right.active,
        ),
    };
};

export const useUserCallRights = () => useOwnUserRights();
